import { Avatar, Icon, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import useMobile from 'hooks/useMobile';
import useEnvironment from 'hooks/useEnvironments';
import { CustomerInfoWrapper } from './styled';
import { StackHeader } from '../styled';
import { stringAvatar } from '../../../../helpers/stringAvatar';

type HeaderProps = {
  contactName: string;
};

const Header = ({ contactName }: HeaderProps) => {
  const { t } = useTranslation();
  const { getBasePath } = useEnvironment();

  const { isMobileView } = useMobile();

  const [domain, setDomain] = useState('');

  const handleArrowBackClick = useCallback(() => {
    window.open(domain, '_self');
  }, [domain]);

  useEffect(() => {
    const path = getBasePath();
    setDomain(path);
  }, []);

  return (
    <StackHeader>
      <CustomerInfoWrapper>
        {isMobileView ? (
          <Icon
            data-testid="arrowBackButtonChatHeader"
            onClick={handleArrowBackClick}
            className="fa-solid fa-arrow-left fa-xs"
            sx={{
              color: 'neutral.var80',
            }}
          />
        ) : null}
        <Avatar
          {...stringAvatar(contactName)}
          aria-label={t('contactAvatar')}
          sx={{ bgcolor: 'primary.lighter', color: 'primary.dark', width: '3.2rem', height: '3.2rem' }}
          src=""
        />
        <Typography
          variant={isMobileView ? 'body2' : 'h3'}
          sx={{ cursor: 'pointer' }}
          data-testid="openDrawerClickName"
          noWrap
        >
          {contactName}
        </Typography>
      </CustomerInfoWrapper>
    </StackHeader>
  );
};

export default Header;
